import { MagnifyingGlassIcon } from '@heroicons/react/24/solid';
import { Button, Input } from '@mui/joy';

import { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

import { useOrganizationId } from '@/hooks/useSwr';
import { addQueryParams } from '@/utils/add-query-params';
import { appHubIndexPath } from '@/utils/constants';

const HubSearchBox = ({ inputSx }: { inputSx?: Record<string, any> }) => {
  const navigate = useNavigate();
  const organizationId = useOrganizationId();
  const [searchParams] = useSearchParams();
  const [q, setQ] = useState(searchParams.get('q') || '');

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    navigate(
      addQueryParams(`/${appHubIndexPath}/search`, {
        q,
        organizationId,
      })
    );
  };

  return (
    <form onSubmit={handleSubmit} className="py-4">
      <Input
        name="q"
        placeholder="Search prompts, prompt tags, models..."
        value={q}
        onChange={(e) => setQ(e.target.value)}
        sx={{
          minHeight: 0,
          borderRadius: '9999px',
          px: '16px',
          input: { minHeight: '60px', fontSize: '16px', ...inputSx },
        }}
        endDecorator={
          <Button
            variant="plain"
            color="neutral"
            type="submit"
            sx={{ py: 0, minHeight: 0, mr: '4px' }}
          >
            <MagnifyingGlassIcon className="h-5 w-5" />
          </Button>
        }
      />
    </form>
  );
};

export default HubSearchBox;
